<!-- Botón de crear deshabilitado: [textButton]="'Nueva dirección'" (onCreateClick)="create()" -->
<app-page-header
  [pageTitle]="'Direcciones'"
  [showCreateButton]="false"
/>

<!-- Search Form -->
<div class="mb-4 bg-white dark:bg-gray-800 p-4 rounded-lg shadow">
  <app-form [formGroup]="searchForm" (submitted)="search()">
    <div class="grid grid-cols-1 md:grid-cols-12 gap-3">
      <div class="md:col-span-9">
        <app-label for="search-direccion">Buscar por dirección</app-label>
        <app-input-field id="search-direccion" type="text" formControlName="direccion" placeholder="Ej: Avenida Victoria" />
      </div>
      <div class="md:col-span-3 flex items-end gap-2">
        <button type="submit" class="btn-primary flex-1">
          Buscar
        </button>
        <button type="button" (click)="clearSearch()" class="btn-secondary flex-1">
          Limpiar
        </button>
      </div>
    </div>
  </app-form>
</div>

<app-data-table
  [columns]="columns"
  [data]="direcciones"
  [loading]="loading"
  (rowClick)="edit($event.item.id)"
>
  <ng-template appTableCell="acciones" let-item>
    <app-delete-trigger
      [title]="'Eliminar dirección'"
      [subtitle]="'¿Está seguro de eliminar esta dirección? Esta acción no se puede deshacer.'"
      (clickDeleteEvent)="delete(item.id)"
    />
  </ng-template>
</app-data-table>
